import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey: 'NFnOwtM0Xwh0lesDuDoI5xFTJLxtmcBH', // Search-only API key
    nodes: [
      {
        host: 'tqpi62sg9v75l4fxp-1.a1.typesense.net',
        port: 443,
        protocol: 'https',
      },
    ],
    cacheSearchResultsForSeconds: 2 * 60, // Cache for 2 minutes
  },
  // Configuration for sequences collection
  additionalSearchParameters: {
    query_by: 'search_text',
    num_typos: 1,
    max_facet_values: 200,
    facet_strategy: 'exhaustive',
  },
  // Collection-specific search parameters
  collectionSpecificSearchParameters: {
    sequences: {
      query_by: 'search_text',
      num_typos: 1,
      // Align with sequences_v2 schema: only request facets that exist
      facet_by: 'genres,software_type,holiday_type,price,artist_name,album,is_free',
      max_facet_values: 200,
      facet_strategy: 'exhaustive',
      sort_by: '_text_match:desc,created_at:desc',
    },
    sequences_v2: {
      query_by: 'search_text',
      num_typos: 1,
      // Align with sequences_v2 schema: only request facets that exist
      facet_by: 'genres,software_type,holiday_type,price,artist_name,album,is_free',
      max_facet_values: 200,
      facet_strategy: 'exhaustive',
      sort_by: '_text_match:desc,created_at:desc',
    },
    displays: {
      query_by: 'display_name,description,city,state,country',
      num_typos: '1,1,1,1,0',
      facet_by: 'city,state,country,featured',
      sort_by: '_text_match:desc',
    },
  },
  // Enable exact filtering for specific fields
  filterByOptions: {
    genres: { exactMatch: true },
    is_free: { exactMatch: true },
    software_type: { exactMatch: true },
    holiday_type: { exactMatch: true },
    price: { exactMatch: false },
  },
  // Collection-specific filter options
  collectionSpecificFilterByOptions: {
    sequences: {
      genres: { exactMatch: true },
      is_free: { exactMatch: true },
      software_type: { exactMatch: true },
      holiday_type: { exactMatch: true },
      price: { exactMatch: false },
      artist_name: { exactMatch: true },
      album: { exactMatch: true },
    },
    sequences_v2: {
      genres: { exactMatch: true },
      is_free: { exactMatch: true },
      software_type: { exactMatch: true },
      holiday_type: { exactMatch: true },
      price: { exactMatch: false },
      artist_name: { exactMatch: true },
      album: { exactMatch: true },
    },
    displays: {
      city: { exactMatch: true },
      state: { exactMatch: true },
      country: { exactMatch: true },
      featured: { exactMatch: true },
    },
  },
});

export const searchClient = typesenseInstantsearchAdapter.searchClient;
export default typesenseInstantsearchAdapter;